import styled from 'styled-components';

export const SAttendanceContentWrapper = styled.div`
  width: 100%;
`;
